import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tools-reflexionsverhalten',
  templateUrl: './tools-reflexionsverhalten.component.html',
  styleUrls: ['./tools-reflexionsverhalten.component.css']
})
export class ToolsReflexionsverhaltenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/m.altmann/Documents/Projekte/telegärtner/tg-pwa/src/app/tools-reflexionsverhalten/tools-reflexionsverhalten.component.ts